import {
  createSecondGranularityTimestamp,
  getFundRequestId,
} from "../../../../external/util/common/helper";

export const generateIdempotencyToken = ({
  fundRequestId = getFundRequestId(),
  action,
}) => `${fundRequestId}-${action}-${createSecondGranularityTimestamp()}`;
